export const comicCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'completed', name: '已完结', icon: 'ri-check-double-line' },
  { slug: 'ongoing', name: '连载中', icon: 'ri-loader-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-sword-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-emotion-line' },
  { slug: 'thriller', name: '悬疑', icon: 'ri-search-eye-line' },
];

export const comics = [
  {
    id: '1',
    slug: 'beauty-of-angel',
    title: '天使之名',
    author: '金美英',
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20woman%20with%20angel%20wings%20in%20soft%20pastel%20colors%2C%20romantic%20atmosphere%2C%20detailed%20character%20design%2C%20soft%20lighting%2C%20clean%20white%20background%2C%20manga%20cover%20art%20style&width=800&height=1120&seq=comic-cover-01&orientation=portrait',
    category: 'romance',
    status: 'completed',
    chapters: 86,
    rating: 9.2,
    views: 1280000,
    description: '天使之名讲述了普通女孩林恩与神秘天使相遇的浪漫故事。在一次意外中，林恩救下了一位受伤的神秘男子，却不知道他的真实身份是来自天界的天使。两人在相处中逐渐产生感情，但天使的身份却成为了他们之间最大的阻碍...这是一个关于爱与牺牲的动人故事。',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['恋爱', '奇幻', '治愈'],
    updateDate: '2024-12-15',
  },
  {
    id: '2',
    slug: 'dark-revenge',
    title: '暗黑复仇记',
    author: '李正洙',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20atmospheric%20Korean%20manhwa%20cover%20featuring%20a%20mysterious%20man%20in%20black%20suit%2C%20dramatic%20lighting%20with%20red%20accents%2C%20revenge%20theme%2C%20intense%20expression%2C%20dark%20gradient%20background%2C%20thriller%20manga%20style&width=800&height=1120&seq=comic-cover-02&orientation=portrait',
    category: 'thriller',
    status: 'completed',
    chapters: 120,
    rating: 9.5,
    views: 2150000,
    description: '暗黑复仇记以韩国首尔为背景，讲述了男主角为被陷害致死的家人复仇的故事。主角韩宇镇曾是前途光明的检察官，却因一起冤案失去一切。十年后他化身神秘人物回归，一步步揭露真相...剧情紧凑、反转不断。',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['悬疑', '动作', '犯罪'],
    updateDate: '2024-11-28',
  },
  {
    id: '3',
    slug: 'magic-academy',
    title: '魔法学院',
    author: '朴佑镇',
    coverImage: 'https://readdy.ai/api/search-image?query=Colorful%20Korean%20fantasy%20manhwa%20illustration%20of%20a%20young%20magic%20student%20with%20glowing%20magic%20spell%2C%20magic%20academy%20theme%2C%20bright%20vibrant%20colors%2C%20energetic%20pose%2C%20clean%20light%20background%2C%20adventure%20manga%20style&width=800&height=1120&seq=comic-cover-03&orientation=portrait',
    category: 'fantasy',
    status: 'ongoing',
    chapters: 45,
    rating: 8.8,
    views: 890000,
    description: '魔法学院讲述了一群年轻魔法学徒在埃尔德里奇魔法学院的成长故事。主角李晨曦是来自普通家庭的天才少年，被破格录取进入这所顶级魔法学府。在这里他结识了各具特色的朋友，也面临着各种挑战和阴谋...',
    isHot: false,
    isNew: true,
    isRecommended: true,
    tags: ['奇幻', '校园', '冒险'],
    updateDate: '2025-01-05',
  },
  {
    id: '4',
    slug: 'love-in-seoul',
    title: '首尔恋歌',
    author: '崔秀英',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20manhwa%20cover%20showing%20a%20couple%20walking%20under%20cherry%20blossoms%20in%20Seoul%2C%20soft%20pink%20color%20palette%2C%20tender%20atmosphere%2C%20beautiful%20spring%20scenery%2C%20clean%20pastel%20background%2C%20shoujo%20manga%20style&width=800&height=1120&seq=comic-cover-04&orientation=portrait',
    category: 'romance',
    status: 'ongoing',
    chapters: 62,
    rating: 9.0,
    views: 1560000,
    description: '首尔恋歌是一部温暖治愈的都市恋爱漫画。工作狂女设计师姜素拉和自由摄影师金泰亨因为一次偶然的邻居相遇而展开的故事。两人在首尔这座繁华都市中互相治愈、共同成长，展现了现代都市爱情的甜蜜与温暖。',
    isHot: true,
    isNew: false,
    isRecommended: false,
    tags: ['恋爱', '都市', '治愈'],
    updateDate: '2024-12-20',
  },
  {
    id: '5',
    slug: 'martial-god',
    title: '武神传说',
    author: '郑宇成',
    coverImage: 'https://readdy.ai/api/search-image?query=Dynamic%20Korean%20action%20manhwa%20illustration%20of%20a%20martial%20artist%20in%20combat%20pose%20with%20energy%20effects%2C%20martial%20arts%20theme%2C%20orange%20and%20gold%20color%20scheme%2C%20powerful%20atmosphere%2C%20clean%20background%2C%20shounen%20style&width=800&height=1120&seq=comic-cover-05&orientation=portrait',
    category: 'action',
    status: 'completed',
    chapters: 200,
    rating: 9.3,
    views: 3200000,
    description: '武神传说是一部宏大的武侠奇幻漫画。故事发生在一个武者为尊的世界，主角叶无道从一个被废掉修为的落魄武者，通过奇遇和自身努力一步步重回巅峰，最终成为一代武神的传奇故事。热血澎湃的战斗场面和细腻的人物刻画令人欲罢不能。',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['动作', '武侠', '热血'],
    updateDate: '2024-10-10',
  },
  {
    id: '6',
    slug: 'tears-of-moon',
    title: '月之泪',
    author: '尹智秀',
    coverImage: 'https://readdy.ai/api/search-image?query=Emotional%20Korean%20drama%20manhwa%20cover%20with%20a%20woman%20under%20moonlight%2C%20melancholy%20expression%2C%20blue%20and%20silver%20color%20palette%2C%20dreamy%20atmosphere%2C%20tears%20sparkling%2C%20clean%20dark%20background%2C%20josei%20style&width=800&height=1120&seq=comic-cover-06&orientation=portrait',
    category: 'drama',
    status: 'completed',
    chapters: 95,
    rating: 9.1,
    views: 1890000,
    description: '月之泪是一部深刻感人的家庭伦理漫画。故事围绕三姐妹在母亲去世后各自面对的人生抉择展开。大姐背负家庭重担，二姐追求自我实现，小妹在迷茫中寻找方向...细腻的情感描绘让无数读者潸然泪下。',
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ['剧情', '家庭', '感人'],
    updateDate: '2024-09-22',
  },
  {
    id: '7',
    slug: 'demon-hunter',
    title: '猎魔人',
    author: '姜东元',
    coverImage: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20Korean%20manhwa%20illustration%20of%20a%20demon%20hunter%20with%20sword%2C%20gothic%20style%2C%20mysterious%20atmosphere%2C%20black%20and%20crimson%20color%20scheme%2C%20supernatural%20theme%2C%20clean%20dark%20background%2C%20action%20manga%20style&width=800&height=1120&seq=comic-cover-07&orientation=portrait',
    category: 'action',
    status: 'ongoing',
    chapters: 78,
    rating: 8.7,
    views: 720000,
    description: '猎魔人设定在一个妖魔横行的世界。主角金贤秀是一名猎魔人组织的成员，拥有特殊能力可以感知和消灭妖魔。在一次任务中他发现了关于自己身世的惊天秘密，从此踏上了寻找真相的危险旅程...',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['动作', '奇幻', '冒险'],
    updateDate: '2025-01-02',
  },
  {
    id: '8',
    slug: 'office-romance',
    title: '办公室罗曼史',
    author: '韩素希',
    coverImage: 'https://readdy.ai/api/search-image?query=Modern%20Korean%20office%20romance%20manhwa%20cover%20featuring%20a%20stylish%20couple%20in%20business%20attire%2C%20warm%20modern%20office%20background%2C%20professional%20yet%20romantic%20vibe%2C%20soft%20warm%20lighting%2C%20clean%20design%2C%20webtoon%20style&width=800&height=1120&seq=comic-cover-08&orientation=portrait',
    category: 'romance',
    status: 'ongoing',
    chapters: 34,
    rating: 8.5,
    views: 450000,
    description: '办公室罗曼史是一部轻松搞笑的职场恋爱漫画。女主角沈恩彩入职了一家知名广告公司，却意外发现自己的直属上司是大学时期的暗恋对象。两人在工作中斗智斗勇，火花四溅，甜蜜又搞笑的办公室恋情就此展开。',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['恋爱', '职场', '喜剧'],
    updateDate: '2025-01-08',
  },
  {
    id: '9',
    slug: 'phantom-thief',
    title: '幻影神偷',
    author: '金泰亨',
    coverImage: 'https://readdy.ai/api/search-image?query=Stylish%20Korean%20thriller%20manhwa%20cover%20of%20a%20phantom%20thief%20in%20elegant%20attire%2C%20moonlight%20scene%2C%20mysterious%20and%20charming%20character%2C%20purple%20and%20silver%20tones%2C%20clean%20night%20background%2C%20mystery%20manga%20style&width=800&height=1120&seq=comic-cover-09&orientation=portrait',
    category: 'thriller',
    status: 'completed',
    chapters: 68,
    rating: 9.0,
    views: 1450000,
    description: '幻影神偷以高智商犯罪为题材。主角是一个被称为"幻影"的神秘大盗，专门盗取不义之财还给受害者。刑警车敏俊追踪幻影三年，两人之间展开了一场惊心动魄的猫鼠游戏。然而真相远比表面看到的更加复杂...',
    isHot: false,
    isNew: false,
    isRecommended: true,
    tags: ['悬疑', '犯罪', '智斗'],
    updateDate: '2024-11-15',
  },
  {
    id: '10',
    slug: 'kingdom-of-dragons',
    title: '龙之国度',
    author: '宋智孝',
    coverImage: 'https://readdy.ai/api/search-image?query=Epic%20Korean%20fantasy%20manhwa%20illustration%20with%20a%20dragon%20rider%20and%20magnificent%20dragon%2C%20medieval%20fantasy%20setting%2C%20golden%20and%20green%20color%20scheme%2C%20grand%20atmosphere%2C%20clean%20sky%20background%2C%20adventure%20manga%20style&width=800&height=1120&seq=comic-cover-10&orientation=portrait',
    category: 'fantasy',
    status: 'ongoing',
    chapters: 56,
    rating: 9.4,
    views: 2780000,
    description: '龙之国度构建了一个龙与人类共存的奇幻世界。少女艾莉亚在一次意外中与传说中的黄金龙建立了心灵链接，成为千年来的第一位龙骑士。她必须学会驾驭龙的力量，在各方势力的角逐中保护自己珍视的一切。',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['奇幻', '冒险', '史诗'],
    updateDate: '2024-12-25',
  },
  {
    id: '11',
    slug: 'school-detective',
    title: '校园侦探社',
    author: '吴世勋',
    coverImage: 'https://readdy.ai/api/search-image?query=Youthful%20Korean%20school%20mystery%20manhwa%20cover%20with%20students%20investigating%2C%20detective%20theme%2C%20bright%20school%20setting%2C%20curious%20expressions%2C%20clean%20classroom%20background%2C%20slice%20of%20life%20manga%20style&width=800&height=1120&seq=comic-cover-11&orientation=portrait',
    category: 'drama',
    status: 'ongoing',
    chapters: 41,
    rating: 8.3,
    views: 380000,
    description: '校园侦探社是一部青春校园推理漫画。高中生朴智勋创办了学校的第一个侦探社，和四位性格迥异的社员一起解决校园中的各种谜题。从失踪的考试卷到神秘的情书，每个案件背后都藏着温暖人心的故事。',
    isHot: false,
    isNew: true,
    isRecommended: false,
    tags: ['剧情', '校园', '推理'],
    updateDate: '2025-01-10',
  },
  {
    id: '12',
    slug: 'blood-rose',
    title: '血蔷薇',
    author: '李多海',
    coverImage: 'https://readdy.ai/api/search-image?query=Gothic%20Korean%20romance%20manhwa%20cover%20with%20a%20mysterious%20woman%20holding%20a%20red%20rose%2C%20vampire%20theme%2C%20dark%20romantic%20atmosphere%2C%20red%20and%20black%20color%20scheme%2C%20clean%20dark%20background%2C%20dark%20romance%20style&width=800&height=1120&seq=comic-cover-12&orientation=portrait',
    category: 'romance',
    status: 'completed',
    chapters: 110,
    rating: 9.3,
    views: 2950000,
    description: '血蔷薇是一部暗黑浪漫风格的吸血鬼题材漫画。在19世纪的欧洲背景下，贵族少女伊丽莎白被卷入吸血鬼世界的纷争。神秘的吸血鬼伯爵给她带来了永生与爱情，却也带来了无尽的危险与抉择。华丽而黑暗的视觉风格令人沉醉。',
    isHot: true,
    isNew: false,
    isRecommended: true,
    tags: ['恋爱', '吸血鬼', '暗黑'],
    updateDate: '2024-10-30',
  },
];

export const banners = [
  {
    id: 'b1',
    title: '武神传说',
    subtitle: '热血归来，武神之路永不止步',
    description: '累计阅读量突破320万！全网最火爆的武侠奇幻漫画',
    comicId: '5',
    image: 'https://readdy.ai/api/search-image?query=Epic%20martial%20arts%20scene%20with%20warrior%20silhouette%20against%20golden%20sunset%2C%20dramatic%20clouds%2C%20ancient%20Chinese%20landscape%20painting%20style%20blended%20with%20modern%20manhwa%20aesthetic%2C%20warm%20golden%20and%20orange%20tones%2C%20heroic%20atmosphere%2C%20clean%20composition&width=1600&height=700&seq=banner-01&orientation=landscape',
  },
  {
    id: 'b2',
    title: '龙之国度',
    subtitle: '龙骑士的传奇冒险，等你来见证',
    description: '评分9.4！奇幻史诗巨作，龙与人类的壮丽篇章',
    comicId: '10',
    image: 'https://readdy.ai/api/search-image?query=Magnificent%20fantasy%20landscape%20with%20dragon%20flying%20over%20medieval%20kingdom%2C%20epic%20scale%2C%20warm%20golden%20hour%20lighting%2C%20green%20valleys%20and%20castles%2C%20fantasy%20illustration%20style%2C%20cinematic%20composition&width=1600&height=700&seq=banner-02&orientation=landscape',
  },
  {
    id: 'b3',
    title: '暗黑复仇记',
    subtitle: '一场跨越十年的复仇，真相即将揭开',
    description: '评分9.5！悬疑犯罪巅峰之作，每一页都是反转',
    comicId: '2',
    image: 'https://readdy.ai/api/search-image?query=Dark%20noir%20cityscape%20at%20night%20with%20rain%2C%20mysterious%20figure%20in%20silhouette%2C%20neon%20reflections%20on%20wet%20streets%2C%20atmospheric%20thriller%20mood%2C%20deep%20blacks%20with%20crimson%20accents%2C%20cinematic%20composition&width=1600&height=700&seq=banner-03&orientation=landscape',
  },
];

export const siteInfo = {
  name: '韩漫网',
  description: '韩漫网致力于为韩漫爱好者提供最齐全的韩漫全集、韩漫完结和韩漫完整版资源。我们精心整理热门韩漫全本已完结作品，支持下拉式免费阅读体验，让韩漫大全追更不迷路。',
  founded: '2020年',
  email: 'contact@hanmanweb.com',
  wechat: 'hanmanweb_official',
  qq: '1234567890',
};